import { render, staticRenderFns } from "./AdminEditAnnouncements.vue?vue&type=template&id=88ec04a2"
import script from "./AdminEditAnnouncements.vue?vue&type=script&lang=ts"
export * from "./AdminEditAnnouncements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports